<template>
  <div class="view-tasklists">
    <user-menu />
    <div class="wrapper">
      <masteradmin-sidebar-menu v-if="((masterAdmin === true) && (!$store.state.switch_admin_username))" />
      <admin-sidebar-menu v-if="((admin === true) || ($store.state.switch_admin_username))" />
        <div class="content-wrapper">
            <div class="container-wrapper center">
                <div>
                    <h3 class="d-inline heading">{{ pageHeading }}</h3>
                    <flash-message autoHide variant="success"></flash-message>
                    <div class="heading-seperator"></div>
                    <div class="col-12 p-0">
                        <div v-if="successMsg" class="alert alert-success mt-2">{{ successMsg }}</div>
                        <div class="search-padd">
                            <div class="col-xs-12 override-padding mt-2">
                                <div :class="'edit_form_manager_heading ' + getFormHeadingOne(form_fields_obj.forms.public_flag) + ' text-align-left'">Form Name</div>
                                <div class="edit_form_manager_heading form_heading_2 text-align-left" v-if="form_fields_obj.forms.public_flag">Affiliate</div>
                                <div class="edit_form_manager_heading form_heading_3 text-align-left">User Type(s)</div>
                                <div class="edit_form_manager_heading form_heading_4 text-align-left">Status</div>
                                <div class="edit_form_manager_heading form_heading_5 text-align-center">&nbsp;</div>
                            </div>
                            <div style="clear: both;"></div>
                            <div class="admin_details" id="mentee_details_more">
                                <div :class="'edit_form_field_lists ' + getFormHeadingOne(form_fields_obj.forms.public_flag)+ ' text-align-left'">
                                    <div class="search-padd">
                                        <input v-model="form_fields_obj.forms.form_name"
                                        name="form_name"
                                        placeholder="Enter Form Name"
                                        class="col-12 col-sm-12 ma-input-field"
                                        v-validate="'required'"
                                        maxlength="255" />
                                        <div v-if="verrors.firstByRule('form_name', 'required')" class="margin-bottom-5 validate-warning-msg">Form name is required</div>
                                    </div>
                                </div>
                                <div class="edit_form_field_lists form_heading_2 text-align-left" v-if="form_fields_obj.forms.public_flag">
                                    <div id="edit-form-affiliate" class="search-padd">
                                        <multiselect
                                            v-model="form_fields_obj.forms.affiliate_selected"
                                            :options="affiliate_options" track-by="name" label="name"
                                            placeholder="Select an Affiliate" :multiple="true" :close-on-select="false" :show-labels="false"
                                            v-validate="'required'"
                                            name="affiliate"
                                            id="affiliate"
                                            class="input_field"
                                            >
                                            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
                                        </multiselect>
                                    </div>
                                    <div v-if="verrors.firstByRule('affiliate', 'required')" class="margin-bottom-5 validate-warning-msg">Affilates is required</div>
                                </div>
                                <div class="edit_form_field_lists form_heading_3 text-align-left">
                                    <div class="search-padd">
                                        <div v-for="(userType, index) in roles_options" :key="index" class="mr-2 float-left">
                                            <input type="checkbox"
                                            :value="userType.value"
                                            v-bind:id="'usertype_'+index"
                                            name="usertype"
                                            v-model="form_fields_obj.forms.usertypes_selected"
                                            v-validate data-vv-rules="required" data-vv-as="User Type"
                                            >
                                            <label :for="'usertype_'+index">{{ userType.name }}</label>
                                        </div>
                                    </div>
                                    <div v-if="verrors.firstByRule('usertype', 'required')" class="margin-bottom-5 mt-3 validate-warning-msg float-left">User Type is required</div>
                                </div>
                                <div class="edit_form_field_lists form_heading_4 text-align-left">
                                    <div class="search-padd">
                                        <select 
                                            class="col-12 col-sm-12 ma-input-field" 
                                            name="status"
                                            v-model="form_fields_obj.forms.status"
                                            v-validate="'required'"
                                        >
                                            <option v-for="(item, index) in statusOptions" :key="index" :value="item.value">{{ item.name }}</option>
                                        </select>
                                        <div v-if="verrors.firstByRule('status', 'required')" class="margin-bottom-5 validate-warning-msg">Status is required</div>
                                    </div>
                                </div>
                                <div class="edit_form_field_lists form_heading_5 text-align-left">
                                    <div class="search-padd">
                                        <button
                                            :disabled="isSubmit"
                                            @click="onSubmit"
                                            type="button"
                                            class="btn btn-red float-right"
                                        >
                                        <b v-if="!isSubmit">Save</b>
                                        <b v-else>Loading...</b>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="clear: both;"></div>
                    <!-- custom field buttons start -->
                    <div class="col-12 p-0">
                        <div class="d-flex bd-highlight mb-3">
                            <div class="mr-auto p-2 bd-highlight"></div>
                            <div class="bd-highlight">
                                <button
                                    v-on:click="isPreloadedAddFieldsModalVisible = true"
                                    class="btn btn-red float-right"
                                ><b><i class="fa fa-plus spacer-icon" aria-hidden="true"></i>Field</b></button>
                            </div>
                            <div class="ml-2 bd-highlight">
                                <button
                                    v-on:click="addCustomFields('custom_field')"
                                    class="btn btn-red float-right"
                                ><b><i class="fa fa-plus spacer-icon" aria-hidden="true"></i>Custom Field</b></button>
                            </div>
                        </div>

                    </div>
                    <div class="form_field_list" v-if="addCustomFieldsShow">
                        <ul v-sortable="{onEnd: reorderFormField, handle: '.handle1'}" class="counter_field-list list-group col-lg-12 override-padding margin-bottom-10">
                            <li class="list-group-item input-height-25 mb-2" v-for="(fieldList, fieldIndex) in form_fields_obj.fields_lists" :key="fieldList.sortid">
                                <div class="field_item">
                                    <div class="col-md-9 col-12 float-left">
                                        <div v-if="fieldList.edit" class="float-left col-lg-11 col-10 override-padding">
                                            <input v-model="fieldList.name"
                                                v-bind:name="'field_name['+fieldIndex+']'"
                                                placeholder="Enter Field Name"
                                                class="col-lg-10 input-height-20"
                                                v-validate="'required'"
                                                maxlength="75" />
                                            <button
                                                v-on:click="updateFormsAction(fieldList)"
                                                class="btn btn-red btn-md input-height-15"
                                                ><b>Save</b></button>
                                            <div v-if="verrors.firstByRule('field_name['+fieldIndex+']', 'required')" class="margin-bottom-5 validate-warning-msg">Field name is required</div>
                                        </div>
                                        <div v-else class="handle1 float-left col-lg-11 col-10 override-padding" style="padding-top: 2px;">
                                            <i aria-hidden="true" class="fa fa-arrows padding-right-5"></i> 
                                            <span data-v-31a1a9be="" class="counter_field-list__counter"></span>
                                            {{ fieldList.name ? fieldList.name : 'Enter Field Name ' }}<i v-if="fieldList.isNameEdit" @click="fieldList.edit = true;" aria-hidden="true" class="cursor-pointer fa fa-pencil-square-o ml-2"></i>
                                        </div>
                                    </div> 
                                    <div class="col-md-3 col-12 float-right override-padding text-align-right">
                                        <i class="cursor-pointer fa fa-times" v-if="form_fields_obj.forms.status == 'DRAFT' || fieldList.update == false" style="padding-left: 10px;" aria-hidden="true" @click="deleteFormFieldConfirm(fieldIndex)"></i>
                                    </div> 
                                    <div style="clear: both;"></div>
                                </div>
                                <div class="margin-left-35">
                                    <div class="row m-0">
                                        <div class="col-md-9 col-12 field_item_group">
                                            <b-form-select
                                                class="col-lg-9 col-sm-9 col-8 input-height-15"
                                                style="height: 30px;"
                                                v-model="fieldList.field_type"
                                                v-bind:name="'field_type['+fieldIndex+']'"
                                                v-validate="'required'"
                                                :options="custom_fields_types"
                                                :disabled="fieldList.is_custom ? false : true"
                                                @change="updateFieldType(fieldList)">
                                            </b-form-select>
                                            <div v-if="verrors.firstByRule('field_type['+fieldIndex+']', 'required')" class="margin-bottom-5 validate-warning-msg">Field type is required</div>
                                        </div>
                                        <div class="col-md-3 col-12 field_item_group default_box">
                                        <label >Default:</label>
                                            <div class="form-check form-check-inline" v-for="(option, rindex) in requiredOptions" :key="rindex">
                                                <input 
                                                    class="form-check-input" 
                                                    type="radio" 
                                                    :value="option.value" 
                                                    v-bind:id="'default_' + fieldIndex"
                                                    v-bind:name="'default_['+fieldIndex+']'" 
                                                    v-model="fieldList.is_default"
                                                    @change="updateFieldIsDefault(fieldList)"
                                                    >
                                                <label class="form-check-label" :for="'default_' + fieldIndex">{{ option.text }}</label>
                                            </div>
                                            <div v-if="verrors.firstByRule('default_['+fieldIndex+']', 'required')" class="margin-bottom-5 validate-warning-msg">Default is required</div>
                                        </div>
                                    </div>
                                    <div class="field_item" v-if="fieldList.field_type != '' && fieldList.field_type != 'text'">
                                        <ul v-sortable="{onEnd: reorderFormFieldValues, handle: '.handle2', group: { name: 'field-' + fieldIndex, put: createFieldOptionValuesGroupArray() }}" class="counter_field_option-list list-group col-lg-12 override-padding margin-bottom-10 field_values_ul" :data-id="fieldIndex">
                                            <li class="list-group-item input-height-25 mb-2" v-for="(fieldVal, fIndex) in fieldList.field_values" :key="fieldVal.sortid">
                                                <div class="handle2 float-left col-md-8 col-12 override-padding">
                                                    <i aria-hidden="true" class="fa fa-arrows padding-right-5"></i> 
                                                    <span class="counter_field_option-list__counter"></span>
                                                    <input v-model="fieldVal.optionValue"
                                                        placeholder="Enter Field Answer"
                                                        class="col-6 input-height-20"
                                                        maxlength="75"
                                                        @keyup="updateFieldOptionValue(fieldVal, fieldIndex)"
                                                        @blur="updateFieldOptionValue(fieldVal, fieldIndex)" />
                                                </div>
                                                <div class="col-md-3 col-12 float-right override-padding text-align-right">
                                                    <i v-if="fieldList.is_custom && (form_fields_obj.forms.status == 'DRAFT'  || fieldList.update == false)" class="cursor-pointer fa fa-times" style="padding-left: 10px;" aria-hidden="true" @click="deleteFieldAnswerConfirm(fIndex, fieldIndex)"></i>
                                                </div> 
                                                <div style="clear: both;"></div>
                                            </li>
                                        </ul>
                                        <div class="d-flex justify-content-end mt-2 mb-2" v-if="fieldList.field_type != 'text'">
                                            <button
                                                v-on:click="addFieldAnswersAction(fieldIndex, fieldList)"
                                                class="btn btn-red float-right"
                                            ><b>Add Fields</b></button>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div class="d-flex justify-content-end mt-2 mb-2" v-if="form_fields_obj.fields_lists.length > 0">
                            <button
                                type="button"
                                @click="onSubmit"
                                :disabled="isSubmit"
                                class="btn btn-red float-right"
                            >
                            <b v-if="!isSubmit">Save</b>
                            <b v-else>Loading...</b>
                            </button>
                        </div>
                    </div>
                    <!-- custom field buttons end -->
                </div>
                <div style="clear: both" ></div>

                <!-- preloaded fields modal start -->
                <PreloadedAddFieldsModal :isModalVisible="isPreloadedAddFieldsModalVisible" @close="closePreloadedAddFieldsModal()">
                    <span v-if="loading" class="pull-right text-danger">
                    Loading...
                    </span>
                    <div slot="header" class="sub-heading"><h3>Add Fields</h3></div>
                    <div slot="body" v-if="isPreloadedAddFieldsModalVisible === true">
                        <p>Select Fields to add:</p>
                        <form @submit.prevent="addPreloadedFields()">
                            <div class="row" v-for="(field, index) in preloaded_fields_options" :key="index">
                                <div class="col-12 ml-2" v-if="field.id">
                                    <input type="checkbox"
                                    :value="field.weight"
                                    v-bind:id="'field_'+index"
                                    name="preloaded_fields"
                                    v-model="preloaded_fields_selected"
                                    :disabled="isPreloadedFieldAlreadyAdded(field.weight)"
                                    >
                                    <label :for="'field_'+index">{{ field.name }}</label>
                                </div>
                            </div>
                            <div v-if="preloaded_fields_errors" class="margin-bottom-5 validate-warning-msg">Select Fields to add is required</div>
                            <div style="clear: both;" class="margin-bottom-10"></div>
                            <div class="col-12 override-padding text-align-right">
                                <button 
                                    type="submit"
                                    class="btn btn-primary btn-sm fmAddBtn"
                                ><b>Add Field(s)</b></button>
                            </div>
                        </form>
                    </div>
                    <div slot="footer" class="col-3 override-padding">

                    </div>
                </PreloadedAddFieldsModal>
                <!-- preloaded fields modal end -->

                
                <ValidationModal :isModalVisible="isValidationModalVisible" @close="isValidationModalVisible = false">
                    <span v-if="loading" class="pull-right text-danger">Loading...</span>
                    <div slot="header" class="sub-heading">{{ validationMessage }}</div>
                    <div slot="body">

                    </div>
                    <div slot="footer" class="col-3 override-padding">

                    </div>
                </ValidationModal>


                <DeleteModal :isModalVisible="isDeleteModalVisible" :id="id" :parent_id="parent_id" @close="isDeleteModalVisible = false">
                    <span v-if="loading" class="pull-right text-danger">
                        Loading...
                    </span>
                    <div slot="header" class="sub-heading">{{ deleteMessage }}</div>
                    <div slot="body">

                    </div>
                    <div slot="footer" class="col-3 override-padding">
                        <button class="left col-12 btn btn-red" @click="isDeleteModalVisible = false; deleteAction()">Confirm</button>
                    </div>
                </DeleteModal>
            </div>
        </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import router from '../../router/index.js';
import store from '../../store/store.js';
import ValidationModal from '../shared/validation_modal_alert.vue';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';
import Sortable from 'sortablejs';
import VeeValidate from 'vee-validate';
import Multiselect from 'vue-multiselect';
import PreloadedAddFieldsModal from '../admin/add_preloaded_fields_modal.vue';
import DeleteModal from '../shared/delete_modal_alert.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

Vue.directive('sortable', {
  inserted: function (el, binding) {
    var sortable = new Sortable(el, binding.value || {});
  }
});

export default {
        data() {
          return {
            isSubmit: false,
            isPreloadedAddFieldsModalVisible: false,
            isDeleteModalVisible: false,
            loading: false,
            isValidationModalVisible: false,
            validationMessage: '',
            masterAdmin: false,
            admin: false,
            form_result: [],
            pageHeading: 'Forms',
            content: '',
            affiliate_options: [],
            roles_options: [
              {
                name: 'Manager',
                value: 'ROLE_ADMIN',
              },
              {
                name: 'Mentor',
                value: 'ROLE_MENTOR',
              },
              {
                name: 'Mentee',
                value: 'ROLE_MENTEE',
              },
              {
                name: 'Apprentice',
                value: 'ROLE_APPRENTICE',
              },
            ],
            statusOptions: [
              {
                name: 'Draft',
                value: 'DRAFT',
              },
              {
                name: 'Published',
                value: 'PUBLISH',
              },
            ],
            preloaded_fields_errors: false,
            preloaded_fields_selected: [],
            custom_fields_types: [
                {
                    text: 'Select Field Type',
                    value: '',
                },
                {
                    text: 'Check Box',
                    value: 'checkbox',
                },
                {
                    text: 'Radio Button',
                    value: 'radio',
                },
                {
                    text: 'Text Box',
                    value: 'text',
                },
                {
                    text: 'Dropdown Menu',
                    value: 'dropdown',
                }
            ],
            requiredOptions: [{text: 'Optional', value: 0}, {text: 'Required', value: 1}],
            addCustomFieldsShow: false,
            is_enable_field_values: 1,
            form_fields_obj: {
              forms: {
                    id: '',
                    form_name: '',
                    status: '',
                    affiliate_selected: '',
                    usertypes_selected: '',
                    public_flag: '',
              },
              fields_lists: [],
              is_update_fields_lists: false,
              remove_fields_mapping: [],
              remove_field_option_values: [],
              form_field_sort_flag: false,
              form_field_sort_field_option_valuesId: [],
              formfieldupdate: false,
            },
            deleteList: '',
            deleteMessage: '',
            id: '',
            parent_id: '',
            formId: '',
            successMsg: '',
            is_custom_field_added: false,
            filter_preloaded_ids: [],
            assigned_form_fields: [],
            preloaded_fields_config: [],
            preloaded_fields_options: [],
            preloaded_fields_options_map: [],
            weight_orders: {},
          }
        },
        components: {
          UserMenu,
          GoBack,
          ValidationModal,
          MasteradminSidebarMenu,
          AdminSidebarMenu,
          Multiselect,
          PreloadedAddFieldsModal,
          DeleteModal,
        },
        methods: {
            getFormHeadingOne(is_public) {
                return (is_public) ? "form_heading_1" : "form_heading_one";
            },
          navigate(pathUrl) {
            router.go({
              path: pathUrl,
              force: true
            });
          },
          fetchAffiliateOptions: function() {
            axios.get('/affiliateoptions', {

            })
            .then((response) => {
                for(var i=0; i < response.data.length; i++) {
                    var affiliate_option = {value: response.data[i].id, name: response.data[i].name};
                    this.affiliate_options.push(affiliate_option);
                }
            })
            .catch(error => {

            });

          },
          changed() {
            if(this.form_fields_obj.formfieldupdate == true) {
              this.content = "Editted";
            }
            else {
              this.content = "";
            }
            return this.content !== ''
          },
          addPreloadedFields() {
              if (this.preloaded_fields_selected.length > 0) {
                  this.preloaded_fields_errors = false;
                  this.filter_preloaded_ids = [];
                  
                    this.preloaded_fields_selected.sort(function(a, b) {
                        return a - b;
                    });
                    // console.log(this.preloaded_fields_selected)

                  for (var h = 0; h < this.preloaded_fields_selected.length; h++) {
                      var findPid = this.weight_orders[this.preloaded_fields_selected[h]];
                      if (this.assigned_form_fields.indexOf(findPid) === -1) {
                        this.assigned_form_fields.push(findPid);
                        this.filter_preloaded_ids.push(findPid);
                      }
                  }
                // console.log(this.assigned_form_fields)
                // console.log(this.filter_preloaded_ids)
                if (this.filter_preloaded_ids.length != 0) {
                    this.addCustomFields('field');
                }
                this.closePreloadedAddFieldsModal();
              } else {
                  this.preloaded_fields_errors = true;
              }
          },
          closePreloadedAddFieldsModal() {
              this.isPreloadedAddFieldsModalVisible = false;
              this.preloaded_fields_errors = false;
              if (this.assigned_form_fields.length == 0){
                  this.preloaded_fields_selected = [];
              }
          },
          isPreloadedFieldAlreadyAdded(fieldId) {
              var findPid = this.weight_orders[fieldId];
              if(this.assigned_form_fields.indexOf(findPid) !== -1) {
                  return true;
              } else {
                  return false;
              }
          },
          reorderFormField ({oldIndex, newIndex}) {
                this.form_fields_obj.formfieldupdate = true;
                const movedItem = this.form_fields_obj.fields_lists.splice(oldIndex, 1)[0];
                this.form_fields_obj.fields_lists.splice(newIndex, 0, movedItem);
                this.form_fields_obj.form_field_sort_flag = true;
                setTimeout(() => {
                    var j=1;
                    for(var i=0; i < this.form_fields_obj.fields_lists.length; i++) {
                        this.form_fields_obj.fields_lists[i].sortid = 'form-' + j;
                        j++;
                    }
                    this.$store.dispatch('forms_manager', this.form_fields_obj);
                }, 1000);
                this.$store.dispatch('forms_manager', this.form_fields_obj);
                //console.log(this.form_fields_obj)
          },
          reorderFormFieldValues (event) {
            this.form_fields_obj.formfieldupdate = true;
            var from_index = event.from.attributes[1].value;
            var to_index = event.to.attributes[1].value;
            if(from_index === to_index) {
                var parent_index = event.from.attributes[1].value;
                const movedItem = this.form_fields_obj.fields_lists[parent_index].field_values.splice(event.oldIndex, 1)[0];
                this.form_fields_obj.fields_lists[parent_index].field_values.splice(event.newIndex, 0, movedItem);
                this.form_fields_obj.form_field_sort_field_option_valuesId.push(this.form_fields_obj.fields_lists[parent_index].field_id);
                this.form_fields_obj.form_field_sort_flag = true;
                setTimeout(() => {
                    var parent_sortid = this.form_fields_obj.fields_lists[from_index].sortid;
                    var j=1;
                    for(var i=0; i < this.form_fields_obj.fields_lists[from_index].field_values.length; i++) {
                        this.form_fields_obj.fields_lists[from_index].field_values[i].sortid = parent_sortid + '-form-field-values-' + j;
                        j++;
                    }
                    this.$store.dispatch('forms_manager', this.form_fields_obj);
                }, 1000);
                this.$store.dispatch('forms_manager', this.form_fields_obj);
            }

          },
          createFieldOptionValuesGroupArray: function() {
            var group_list = [];
            for(var i=0; i < this.form_fields_obj.fields_lists.length; i++) {
              if((this.form_fields_obj.fields_lists[i].field_values.length > 0)) {
                group_list.push('form-' + i);
              }
            }
            return group_list;
          },
          deleteFormFieldConfirm(formFieldIndex) {
                this.deleteMessage = 'Are you sure you want to delete? This will delete the related fields and custom fields.';
                this.formFieldIndexValue = formFieldIndex;
                this.deleteList = 'Field';
                this.isDeleteModalVisible = true;
          },
          deleteFieldAnswerConfirm(fIndex, formFieldIndex){
                this.deleteMessage = 'Are you sure you want to delete? This will delete the related field answer.';
                this.formFieldAnswerIndexValue = fIndex;
                this.formFieldIndexValue = formFieldIndex;
                this.deleteList = 'FieldAnswer';
                this.isDeleteModalVisible = true;
          },
          deleteAction: function() {
                this.form_fields_obj.formfieldupdate = true;
                if(this.deleteList == 'Field') {
                    var remove_data = this.form_fields_obj.fields_lists[this.formFieldIndexValue];
                    // remove field id from assigned fields
                    var i = this.assigned_form_fields.indexOf(remove_data.field_id);
                    if(i >= 0) {
                        this.assigned_form_fields.splice(i,1);
                    }
                    // remove field id from preloaded fields                        
                    var findPid = this.weight_orders[remove_data.field_id];
                    var j = this.preloaded_fields_selected.indexOf(remove_data.preloaded_field_weight);
                    if(j >= 0) {
                        this.preloaded_fields_selected.splice(j,1);
                    }
                    if(remove_data.update == true) {
                        this.form_fields_obj.remove_fields_mapping.push(remove_data.form_field_mapping_id);
                        this.form_fields_obj.fields_lists.splice(this.formFieldIndexValue, 1);
                    } else {
                        this.form_fields_obj.fields_lists.splice(this.formFieldIndexValue, 1);
                    }

                    var j=1;
                    for(var i=0; i < this.form_fields_obj.fields_lists.length; i++) {
                        this.form_fields_obj.fields_lists[i].sortid = 'form-' + j;
                        j++;
                    }
                    this.$store.dispatch('forms_manager', this.form_fields_obj);
                }
                if(this.deleteList == 'FieldAnswer') {
                    var remove_data = this.form_fields_obj.fields_lists[this.formFieldIndexValue].field_values[this.formFieldAnswerIndexValue];
                    if(remove_data.update == true) {
                        this.form_fields_obj.remove_field_option_values.push(remove_data.field_option_value_id);
                        this.form_fields_obj.fields_lists[this.formFieldIndexValue].field_values.splice(this.formFieldAnswerIndexValue, 1);
                    } else {
                        this.form_fields_obj.fields_lists[this.formFieldIndexValue].field_values.splice(this.formFieldAnswerIndexValue, 1);
                    }

                    var parent_sortid = this.form_fields_obj.fields_lists[this.formFieldIndexValue].sortid;
                    var j=1;
                    for(var i=0; i < this.form_fields_obj.fields_lists[this.formFieldIndexValue].field_values.length; i++) {
                        this.form_fields_obj.fields_lists[this.formFieldIndexValue].field_values[i].sortid = parent_sortid + '-form-field-values-' + j;
                        j++;
                    }
                    this.$store.dispatch('forms_manager', this.form_fields_obj);
                }
          },
          fetchFormFields() {
            axios.get('/preloaded-form-fields')
            .then((resp) => {
                this.loading = false;
                this.preloaded_fields_options = resp.data.display_result;
                this.preloaded_fields_options_map = resp.data.data;
                this.weight_orders = resp.data.weight_orders;
                this.preloaded_fields_config.configPreloadedFields = resp.data.option_values;
                this.preloaded_fields_config.optionFields = resp.data.option_fields;
            })
            .catch(error => {

            });
          },
          checkRemoveField(mappingFieldId) {
              var i = this.form_fields_obj.remove_fields_mapping.indexOf(mappingFieldId);
              return (i >= 0) ? true : false;
          },
          fetchFormManager() {
                this.form_fields_obj.fields_lists = [];
                this.assigned_form_fields = [];
                this.preloaded_fields_selected = [];
                axios.get('/forms-manager/' + this.formId)
                .then((resp) => {
                    this.successMsg = '';
                    this.loading = false;
                    this.addCustomFieldsShow = true;
                    this.form_result = resp.data.forms;
                    this.form_fields_obj.forms.id = this.form_result.form_id;
                    this.form_fields_obj.forms.form_name = this.form_result.form_name;
                    this.form_fields_obj.forms.status = this.form_result.form_status;
                    this.form_fields_obj.forms.affiliate_selected = this.form_result.affiliate_assigned;
                    this.form_fields_obj.forms.usertypes_selected = this.form_result.roles_assigned;
                    this.form_fields_obj.forms.public_flag = this.form_result.public_flag;
                    var form_fields_length = resp.data.form_fields.length;
                    if (form_fields_length) {
                        this.is_update_fields_lists = true;
                    }
                    for (var p = 0; p < form_fields_length; p++) {
                        if (!resp.data.form_fields[p].isCustom) {
                            this.assigned_form_fields.push(resp.data.form_fields[p].field_id);
                            this.preloaded_fields_selected.push(resp.data.form_fields[p].preloaded_field_weight);
                        }
                        var fieldObj = {
                            field_id: resp.data.form_fields[p].field_id,
                            name: resp.data.form_fields[p].field_name,
                            is_default: resp.data.form_fields[p].isDefault,
                            field_type: resp.data.form_fields[p].field_type,
                            field_weight: resp.data.form_fields[p].field_weight,
                            preloaded_field_weight: resp.data.form_fields[p].preloaded_field_weight,
                            is_custom: resp.data.form_fields[p].isCustom,
                            status: resp.data.form_fields[p].field_status,
                            form_field_mapping_id: resp.data.form_fields[p].form_field_mapping_id,
                            field_values: resp.data.form_fields[p].field_values,
                            is_enable_field_values: this.is_enable_field_values,
                            isNameEdit: (resp.data.form_fields[p].isCustom) ? true: false,
                            edit: resp.data.form_fields[p].edit,
                            update: this.checkRemoveField(resp.data.form_fields[p].form_field_mapping_id) ? false : resp.data.form_fields[p].update,
                            modified: resp.data.form_fields[p].modified,
                            sortid: 'form-' + (p + 1),
                        };
                        this.form_fields_obj.fields_lists.push(fieldObj)
                    }
                    //console.log(this.form_fields_obj.fields_lists)
                })
                .catch(error => {

                });
          },
          addCustomFields: function(event) {
                this.addCustomFieldsShow = true;
                this.form_fields_obj.formfieldupdate = true;
                var form_fields_lists_len = this.form_fields_obj.fields_lists.length + 1;
                var fieldAddedCount = 1;
                var field_data = [];
                if (event == "field") {
                    if (this.is_custom_field_added || this.is_update_fields_lists) {
                        fieldAddedCount = this.filter_preloaded_ids.length;
                        field_data = this.filter_preloaded_ids;
                    } else {
                        this.form_fields_obj.fields_lists = [];
                        form_fields_lists_len = 1;
                        fieldAddedCount = this.assigned_form_fields.length;
                        field_data = this.assigned_form_fields;
                    }
                } else {
                    this.is_enable_field_values = 1;
                    this.is_custom_field_added = true;
                }
                var fName = '';
                var fType = '';
                var fValue = '';
                var fWeight = '';
                var isCustom = 1;
                var fDefault = 0;
                for (var k = 0; k < fieldAddedCount; k++) {
                    var field_sort_name = 'form-' + (form_fields_lists_len + k);
                    if (event == "field") {
                        fName = this.preloaded_fields_options_map[field_data[k]].name;
                        fType = this.preloaded_fields_options_map[field_data[k]].type;
                        isCustom = this.preloaded_fields_options_map[field_data[k]].isCustom;
                        fValue = this.preloaded_fields_options_map[field_data[k]].id;
                        fWeight = this.preloaded_fields_options_map[field_data[k]].weight;
                        fDefault = this.preloaded_fields_options_map[field_data[k]].isDefault;
                        this.is_enable_field_values = this.preloaded_fields_options_map[field_data[k]].is_enable_field_values;
                    }
                    var fieldObj = {
                        field_id: fValue,
                        name: fName,
                        is_default: fDefault,
                        form_field_mapping_id: '',
                        field_type: fType,
                        is_custom: isCustom,
                        field_weight: (form_fields_lists_len + k),
                        preloaded_field_weight: fWeight,
                        status: 'Active',
                        field_values: [],
                        is_enable_field_values: this.is_enable_field_values,
                        isNameEdit: (event == "field") ? 0 : 1,
                        edit: (event == "field") ? 0 : 1,
                        update: false,
                        modified: false,
                        sortid: field_sort_name,
                    };

                    if (this.is_enable_field_values) {
                        if (event == "field") {
                            var preloadValues = this.preloaded_fields_config.configPreloadedFields[fValue];
                            var preloadValuesLength = this.preloaded_fields_config.configPreloadedFields[fValue].length;
                            for (var m = 0; m < preloadValuesLength; m++) {
                                var valueObj = {
                                    field_option_value_id: '',
                                    optionValue: preloadValues[m],
                                    sortid: field_sort_name + '-form-field-values-' + m,
                                    status: 'Active',
                                    update: false,
                                    modified: false, 
                                };
                                fieldObj.field_values.push(valueObj);
                            }
                        } else {
                            for (var m = 1; m <= 2; m++) {
                                var valueObj = {
                                    field_option_value_id: '',
                                    optionValue: '',
                                    sortid: field_sort_name + '-form-field-values-' + m,
                                    status: 'Active',
                                    update: false,
                                    modified: false, 
                                };
                                fieldObj.field_values.push(valueObj);
                            }
                        }
                    }
                    this.form_fields_obj.fields_lists.push(fieldObj);
                }

                //console.log(this.form_fields_obj)

                this.form_fields_obj.form_field_sort_flag = true;
                this.$store.dispatch('forms_manager', this.form_fields_obj);
          },
          addFieldAnswersAction: function(formFieldIndex, fieldList) {
                var isTrue = false;  
                if (fieldList.update) {
                    isTrue = true;
                }
                fieldList.modified = isTrue;
                var fieldAnswerCount = this.form_fields_obj.fields_lists[formFieldIndex].field_values.length + 1;
                this.form_fields_obj.fields_lists[formFieldIndex].field_values.push({
                    field_option_value_id: '',
                    optionValue: '',
                    sortid: fieldList.sortid + '-form-field-values-' + fieldAnswerCount,
                    status: 'Active',
                    update: isTrue,
                    modified: isTrue,
                });
          },
          updateFormsAction: function(fieldList) {
            if(fieldList.name === '') {
              this.validationMessage = 'Please enter the field name';
              this.isValidationModalVisible = true;
              return false;
            }
            this.form_fields_obj.formfieldupdate = true;
            if(fieldList.update === true) {
              fieldList.modified = true;
            }
            fieldList.edit = false;
            this.$store.dispatch('forms_manager', this.form_fields_obj);
          },
          updateFieldType(fieldList) {
            if (fieldList.field_type) {
                if (fieldList.field_type != "text") {
                    this.is_enable_field_values = 0;
                    if (fieldList.field_values.length == 0) {
                        for (var m = 1; m <= 2; m++) {
                            var valueObj = {
                                field_option_value_id: '',
                                optionValue: '',
                                sortid: fieldList.sortid + '-form-field-values-' + m,
                                status: 'Active',
                                update: false,
                                modified: false, 
                            };
                            fieldList.field_values.push(valueObj);
                        }
                    }
                } else {
                    this.is_enable_field_values = 1;
                    if (fieldList.update === true) {
                        for (var p = 0; p < fieldList.field_values.length; p++) {
                            var newItem = fieldList.field_values[p].field_option_value_id;
                            if (this.form_fields_obj.remove_field_option_values.indexOf(newItem) === -1) {
                                this.form_fields_obj.remove_field_option_values.push(newItem);
                            }
                        }
                    }
                }
                  this.form_fields_obj.formfieldupdate = true;
                    if(fieldList.update === true) {
                        fieldList.modified = true;
                    }
                fieldList.edit = false;
                this.$store.dispatch('forms_manager', this.form_fields_obj);
            }
          },
          updateFieldIsDefault(fieldList) {
            this.form_fields_obj.formfieldupdate = true;
            if(fieldList.update === true) {
              fieldList.modified = true;
            }
            fieldList.edit = false;
            this.$store.dispatch('forms_manager', this.form_fields_obj);
          },
          updateFieldOptionValue(fieldVal, fieldIndex) {
              if (fieldVal.optionValue) {
                  this.form_fields_obj.formfieldupdate = true;
                  if(fieldVal.update === true) {
                    fieldVal.modified = true;
                    this.form_fields_obj.fields_lists[fieldIndex].modified = true;
                  }
                fieldVal.edit = false;
                this.$store.dispatch('forms_manager', this.form_fields_obj);
              }
          },
          onSubmit () {
            this.successMsg = '';
            this.$validator.validateAll().then((result) => {
                if ((this.verrors.items.length === 0)) {
                    this.isSubmit = true;
                    this.loading = true;
                    this.form_fields_obj.formfieldupdate = false;
                    //console.log(this.form_fields_obj)
                    axios('/form-fields-list',
                    {
                        method: 'POST',
                        data: {
                            "form_fields_obj": this.form_fields_obj,
                        },
                    })
                    .then((resp) => {
                        this.loading = false;
                        this.isSubmit = false;
                        this.successMsg = 'Form updated successfully';
                        this.$store.dispatch('forms_manager', '');
                        if((this.$store.state.page_url) && 
                            ((this.$store.state.page_url.indexOf('account-lookup') > -1) 
                            || (this.$store.state.page_url.indexOf('account-lookup-detail') > -1) 
                            || (this.$store.state.page_url.indexOf('enterprise-lookup') > -1) 
                            || (this.$store.state.page_url.indexOf('enterprise-lookup-detail') > -1))
                        ) {
                            this.flash({ message: 'Form has been updated successfully.', variant: 'success' });
                            router.push(this.$store.state.page_url);
                        } else {
                            router.push("/forms-manager");
                        }
                    })
                    .catch(error => {
                        this.isSubmit = false;
                    });
                }
            })
            .catch(() => {

            });
          },
        },
        beforeRouteLeave(to, from, next) {
          if (this.changed() && !confirm('Changes that you made to the forms manager is not saved. Please save before leaving.'))
            next(false)
          else
            next()
        },
        beforeMount() {
        	window.addEventListener('beforeunload', this.unload)
        },
        beforeDestroy() {
        	window.removeEventListener('beforeunload', this.unload)
        },
        created: function () {
          this.loading = true;
            this.formId = this.$route.params.form_id;
          var roles = this.$store.state.roles;
          if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
            this.masterAdmin = true;
          }
          if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
            this.admin = true;
          }
          if((this.masterAdmin === true) && ((!this.$store.state.switch_admin_username) || (this.$store.state.switch_admin_username == ''))) {
           this.fetchAffiliateOptions();
          }

          if (this.formId) {
              this.fetchFormManager();
          }

          this.fetchFormFields();
        },
}
</script>

<style scoped>
    .form_heading_1 { 
        width: 30%;
    }
    .form_heading_2 { 
        width: 25%;
    }
    .form_heading_3 { 
        width: 25%;
    }
    .form_heading_4 { 
        width: 10%;
    }
    .form_heading_5 { 
        width: 10%;
    }
    .form_heading_one {
        width: 55%;
    }
    .edit_form_manager_heading {
        background: #8b8b8b none repeat scroll 0 0;
        border-bottom: 2px solid #ddd;
        border-top: 0 none;
        color: #fff;
        float: left;
        line-height: 1.42857;
        padding: 8px 3px;
        vertical-align: bottom;
    }
    .edit_form_field_lists {
        border: 0 none;
        line-height: 1.42857;
        vertical-align: bottom;
        float: left;
        padding: 8px 3px;
    }
    .ma-input-field {
        line-height: 30px;
        margin-bottom: 5px;
        padding: 0 5px;
        color: #707070;
        min-height: 38px;
    }
    .fmAddBtn{
        color: #FFF;
        background-color: #00acee;
        border: 1px solid #00acee;
        padding: 8px !important;
        font-size: 13px;
        font-weight: 900;
        float: right;
    }
    .fmAddBtn:focus, .fmAddBtn:active {
        color: #FFF !important;
        background-color: #00acee !important;
        border: 1px solid #00acee !important;
    }
     ul .list-group-item {
        padding: 0;
    }
    .form_field_list li {
        background: none;
        border: 0px;
    }
    .form_field_list li .field_item, .fieldadd {
        background: #FFF;
        padding: 5px 15px;
    }
    .field_item_group {
        background: #d4d4d4;
        padding: 5px 15px;
    }
    .margin-left-35 { margin-left: 35px; }
    .default_box { text-align: right; padding: 8px; }
    .field_values_ul { padding: 10px; margin: 0 10px; }
    .counter_field-list {
        counter-reset: my-sec-counter1;
    }
    .counter_field-list__counter:after {
        counter-increment: my-sec-counter1;
        content: counter(my-sec-counter1, upper-roman) ". ";
    }
    .counter_field_option-list {
        counter-reset: my-sec-counter2;
    }
    .counter_field_option-list__counter:after {
        counter-increment: my-sec-counter2;
        content: counter(my-sec-counter2, upper-alpha) ". ";
    }
</style>
<style>
#edit-form-affiliate li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#edit-form-affiliate li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: 13px;
  font-weight: 400;
  color: #707070;
  background-color: #fff !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/admin/add_form_custom_fields.vue